import {
	Component,
	OnInit,
	ChangeDetectionStrategy,
	ChangeDetectorRef,
	HostListener
} from "@angular/core";
import { GlobalService } from "../../services/global/global.service";
import { Observable } from "rxjs";
import { DMVStoreService } from "../../services/dmv/dmv-store.service";
import { NavigationStart, Router } from "@angular/router";
import { AppUtil } from "../../utils/app.util";
import { HeaderImageType } from "../../constants/header-image-type.constants";
import { MEGStoreService } from "../../services/meg/meg-store.service";
import { USERStoreService } from "src/app/services/user/user-store.service";
import { USERDataService } from "src/app/services/user/user-data.service";

declare var window: any;
declare var $: any;

@Component({
	selector: "app-header",
	templateUrl: "./header.component.html",
	styleUrls: ["./header.component.css"],
	changeDetection: ChangeDetectionStrategy.OnPush
})
export class HeaderComponent implements OnInit {
	constructor(
		private router: Router,
		public globalService: GlobalService,
		public dmvStoreService: DMVStoreService,
		public megStoreService: MEGStoreService,
		public userStoreService: USERStoreService,
		public userDataService: USERDataService,
		private cd: ChangeDetectorRef
	) {}

	public isAboutVisible: boolean = false;
	public openConfirmModel: boolean = false;
	public show$: Observable<boolean>;

	public headerImageType$: Observable<string>;
	public scrollYPos: number;
	public isLogdin = false;
	public isUsePopupVisible: boolean;
	public confirmationMessage: string;
	public logoutAction: boolean;
	public cancellationToken: boolean = false;
	public hideNotificationForHome: boolean = false;
	ngOnInit() {
		this.globalService.cancellationToken$().subscribe(val => {
			this.cancellationToken = val;

			this.cd.detectChanges();
		});
		AppUtil.log(
			"HeaderComponent ngOnInit: this.globaService.isHeaderDisplayed$ = " +
				this.globalService.getHeaderDisplayedValue()
		);
		this.confirmationMessage =
			"Your shopping cart has not been submitted for processing.  The information about this shopping cart will be lost if you go to the Home page now.  Are you sure you want to go to the Home page?";
		this.show$ = this.globalService.isHeaderDisplay$();

		this.headerImageType$ = this.globalService.getHeaderImageType$();
		this.userStoreService.userProfile$().subscribe(userProfile => {
			if (userProfile && userProfile.megUserGUID) {
				this.isLogdin = true;
			} else {
				this.isLogdin = false;
			}
			this.cd.detectChanges();
		});

		this.router.events.subscribe(val => {
			if (val instanceof NavigationStart) {
				if (val.url === "/home") {
					this.hideNotificationForHome = true;
				} else {
					this.hideNotificationForHome = false;
				}
			}
		});
	}

	public removeConfirm() {
		this.openConfirmModel = false;
	}

	public continueConfirm() {
		this.openConfirmModel = false;
		if (this.logoutAction) {
			this.logout();
		} else {
			this.router.navigate(["home"], { skipLocationChange: true });
		}
	}

	@HostListener("window:message", ["$event"])
	onMessage(message) {
		if (message.data) {
			switch (message.data.action) {
				case "goToHome":
					this.gotoPage("home");
					break;
			}
		}
	}
	public gotoPage(url) {
		if ("home" === url) {
			if (
				!(
					this.dmvStoreService.registrationsInCart.dmvRegistrations ||
					this.dmvStoreService.registrationsInCart.dmvRegistrationsManual ||
					this.dmvStoreService.registrationsInCart.donation ||
					this.dmvStoreService.registrationsInCart.mailingAddress ||
					this.dmvStoreService.registrationsInCart.pickupInPerson
				)
			) {
				this.openConfirmModel = false;
				this.router.navigate(["home"], { skipLocationChange: true });
			} else {
				if (this.dmvStoreService.isPaymentSuccess) {
					this.openConfirmModel = false;
					this.router.navigate(["home"], { skipLocationChange: true });
				} else {
					this.logoutAction = false;
					this.openConfirmModel = true;
				}
			}
			window.closeNav();
			$(".mainBody").show();
			this.isAboutVisible = false;
			this.cd.detectChanges();
		} else {
			window.closeNav();
			this.scrollYPos = window.scrollY;
			window.scroll(0, 0);
			$(".mainBody").hide();
			this.isAboutVisible = true;
			this.cd.detectChanges();
		}
	}
	public closeAbout() {
		this.isAboutVisible = false;
		$(".mainBody").show();
		window.scroll(0, this.scrollYPos);
	}
	public registerNewUser() {
		window.closeNav();
		this.closeAbout();
		this.userStoreService.accountfromLogin = false;
		this.userStoreService.accountCreateFormData = null;
		this.router.navigate(["create-account"], { skipLocationChange: true });
	}
	public logIn() {
		window.closeNav();
		this.closeAbout();
		this.userStoreService.accountCreateFormData = null;
		this.router.navigate(["log-in"], { skipLocationChange: true });
	}
	public setVisiblilityUserPopup(val) {
		this.isUsePopupVisible = val;
	}
	public userAction(type) {
		this.userStoreService.accountCreateFormData = null;
		this.userStoreService.outComeText = "";
		window.closeNav();
		this.closeAbout();
		this.setVisiblilityUserPopup(false);
		switch (type) {
			case "profile":
				this.router.navigate(["profile"], { skipLocationChange: true });
				break;
			case "county-landing":
				this.dmvStoreService.routeFrom = null;
				this.dmvStoreService.registrationsInCart = {};
				this.dmvStoreService.addressrequired = false;
				this.dmvStoreService.paymentDetails = null;
				this.globalService.cartNature = "TBD";
				this.globalService.supportKioskPickup = undefined;
				this.dmvStoreService.registrationsInCart.firstIteration = true;
				this.router.navigate(["county-landing"], { skipLocationChange: true });
				break;
			case "faq":
				this.router.navigate(["account-faqs"], { skipLocationChange: true });
				break;
			case "announcement":
				this.router.navigate(["app-announcement"], {
					skipLocationChange: true
				});
				break;
			case "logout":
				console.log("////    logout  ///////");

				if (this.dmvStoreService.isPaymentSuccess) {
					this.openConfirmModel = false;
					this.logout();
				} else {
					this.logoutAction = true;
					this.openConfirmModel = true;
				}
				//this.logout();

				break;
			default:
		}
	}
	public logout() {
		this.userDataService
			.callLogoutApi(
				this.dmvStoreService.sessionGUID,
				this.userStoreService.getUserProfile().megUserGUID
			)
			.subscribe(response => {
				if (response) {
					window.closeNav();
					AppUtil.log("logout() ==>", response);
					this.userStoreService.setUserProfile(null);
					this.dmvStoreService.addToProfileState = undefined;
					this.globalService.isAnnouncementFlow = true;
					this.globalService.isAnnouncementVisible = false;
					//const url = this.globalService.userActionCallFrom.replace("/", "");
					//this.router.navigate([url], { skipLocationChange: true });
					this.router.navigate(["home"], { skipLocationChange: true });
				}
			});
	}
}
